import { Accordion, ActionIcon, Anchor, Container, Group, Text } from '@mantine/core';
import { Icon } from '@zala-team/ui-web';
import { TbBrandFacebook, TbBrandInstagram, TbBrandLinkedin, TbMail, TbVideo } from 'react-icons/tb';
import { buildUTMUrl } from '#website/helpers.tsx';
import { useLanding } from '#website/layouts/Landing.context.ts';
import { ZalaLogo } from '../logo/ZalaLogo';
import classes from './footer.module.css';

export function FooterContainer() {
	const currentYear = new Date().getFullYear();

	const { landingSource } = useLanding();

	const demoUrl = buildUTMUrl({
		baseUrl: 'https://turnos.zala.app/zala',
		section: 'footer',
		medium: 'cta-button',
		landingType: landingSource,
		content: 'agenda-una-demo',
	});

	const links = [
		{
			title: 'Información',
			links: [
				{ label: 'Términos y condiciones', link: '/ayuda/terminos-y-condiciones' },
				{ label: 'Política de privacidad', link: '/ayuda/politica-de-privacidad' },
				{ label: 'Estado de la plataforma', link: 'https://status.zala.app' },
			],
		},
		{
			title: 'Contacto',
			links: [
				// { label: 'Ayuda', link: '#' },
				{
					label: (
						<Group gap={'2xs'}>
							<Icon size={18} c={'secondary'} icon={<TbMail />} /> hola@zala.app
						</Group>
					),
					link: 'mailto:hola@zala.app',
				},
				{
					label: (
						<Group gap={'2xs'}>
							<Icon size={18} c={'secondary'} ml={1} icon={<TbVideo />} /> Agendá una demo
						</Group>
					),
					link: demoUrl,
				},
			],
		},
		// {
		// 	title: 'Contacto',
		// 	links: [
		// 		{ label: 'Join Discord', link: '#' },
		// 		{ label: 'Follow on Twitter', link: '#' },
		// 		{ label: 'Email newsletter', link: '#' },
		// 		{ label: 'GitHub discussions', link: '#' },
		// 	],
		// },
	];

	const groups = links.map((group) => {
		const linksList = group.links.map((link, index) => (
			<Anchor key={`link-${link.label}-${index}`} className={classes.link} href={link.link}>
				{link.label}
			</Anchor>
		));

		return (
			<div className={classes.wrapper} key={group.title}>
				<Text className={classes.title}>{group.title}</Text>
				{linksList}
			</div>
		);
	});

	// Accordion for mobile
	const groupsAccordion = (
		<Accordion variant='filled'>
			{links.map((group) => (
				<Accordion.Item value={group.title} key={group.title}>
					<Accordion.Control>{group.title}</Accordion.Control>
					<Accordion.Panel pl={'xs'}>
						{group.links.map((link, index) => (
							<Text py={'2xs'} key={`accordion-link-${link.label}-${index}`} className={classes.link} component='a' href={link.link}>
								{link.label}
							</Text>
						))}
					</Accordion.Panel>
				</Accordion.Item>
			))}
		</Accordion>
	);

	return (
		<footer className={classes.footer}>
			<Container className={classes.inner}>
				<div className={classes.logo}>
					<Group gap={'xs'}>
						<ZalaLogo size={{ base: 26, md: 30 }} />
						<Text fz={{ base: 22, md: 24 }} fw={700}>
							Zala
						</Text>
					</Group>
					<Text size='xs' c='dimmed' className={classes.description}>
						Tu negocio en piloto automático
					</Text>
				</div>

				<nav aria-label='Enlaces informátivos' className={classes.groups}>
					{groups}
				</nav>

				{/* Mobile accordion */}
				<nav aria-label='Enlaces informátivos' className={classes.groupsAccordion}>
					{groupsAccordion}
				</nav>
			</Container>
			<Container className={classes.afterFooter}>
				<Text c='dimmed' size='sm'>
					© {currentYear} Zala S.A. Todos los derechos reservados.
				</Text>
				<Group gap='xs' className={classes.social} justify='flex-end' wrap='nowrap'>
					<ActionIcon
						component={'a'}
						href={'https://www.instagram.com/zala_app'}
						target='_blank'
						rel='noreferrer'
						size='lg'
						variant='subtle'
						color='gray'
					>
						<TbBrandInstagram size={26} />
					</ActionIcon>
					<ActionIcon
						component={'a'}
						href={'https://www.facebook.com/zala.global'}
						target='_blank'
						rel='noreferrer'
						size='lg'
						variant='subtle'
						color={'gray'}
					>
						<TbBrandFacebook size={26} />
					</ActionIcon>
					<ActionIcon
						component={'a'}
						href={'https://www.linkedin.com/company/zala-app/'}
						target='_blank'
						rel='noreferrer'
						size='lg'
						variant='subtle'
						color='gray'
					>
						<TbBrandLinkedin size={26} />
					</ActionIcon>
				</Group>
			</Container>
		</footer>
	);
}
